import logo from 'assets/images/logo.svg'
import illustrationDoc from 'assets/images/illustration_doc.svg'
import rightArrow from 'assets/images/rightArrow.svg'
import edit from 'assets/images/edit.svg'
import plus from 'assets/images/plus.svg'
import close from 'assets/images/close.svg'
import trash from 'assets/images/trash.svg'
import home from 'assets/images/home.svg'
import setting from 'assets/images/setting.svg'
import editBlack from 'assets/images/editBlack.svg'
import trashBlack from 'assets/images/trashBlack.svg'
import plusBlack from 'assets/images/plusBlack.svg'
import minusOrange from 'assets/images/minusOrange.svg'
import customArrow from 'assets/images/customArrow.svg'
import mail from 'assets/images/mail.svg'
import call from 'assets/images/call.svg'
import pdf from 'assets/images/pdf.svg'
import add from 'assets/images/add.svg'
import subtract from 'assets/images/subtract.svg'
import calIcon from 'assets/images/calIcon.jpg'
import discontinueIcon from 'assets/images/carbon_medication-alert.png'

export const images = {
  logo,
  illustrationDoc,
  rightArrow,
  edit,
  plus,
  close,
  trash,
  home,
  setting,
  editBlack,
  trashBlack,
  plusBlack,
  minusOrange,
  customArrow,
  mail,
  call,
  pdf,
  add,
  subtract,
  calIcon,
  discontinueIcon
}

export default {}
